import { render } from "./SimpleTableHeader.vue?vue&type=template&id=930a5778"
import script from "./SimpleTableHeader.vue?vue&type=script&lang=js"
export * from "./SimpleTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__